import styled from '@emotion/styled'
import { Box } from '@mui/material'
import { getPxAsRem } from 'shared/utils'

export const Container = styled(Box)`
    padding: ${getPxAsRem(16)};
    background-color: ${({ theme }) => theme.palette.greyscale.white};
    border-radius: ${getPxAsRem(8)};
    overflow: auto;
    height: ${getPxAsRem(270)};
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.2);
`

export const Header = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: ${getPxAsRem(16)};
`

export const StyledCard = styled(Box)`
    width: 100%;
    padding: 0 ${getPxAsRem(8)};
`

export const StyledHeader = styled(Box)`
    border-bottom: 1px solid #e0e0e0;
`

export const StyledRow = styled(Box)`
    display: flex;
    justify-content: space-between;
    padding: ${getPxAsRem(12)} 0;
    border-bottom: 1px solid #e0e0e0;

    &:last-child {
        border-bottom: none;
    }
`

export const StyledCell = styled(Box)`
    flex: 1;
    text-align: left;
    max-width: 33.33%;

    &::nth-of-type(2) {
        text-align: center;
    }

    &::nth-of-type(3) {
        text-align: right;
    }
`

export const NoDataBox = styled(Box)`
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${getPxAsRem(100)};
`
